<template>
  <div class="hello">
    <div class="foote">
      <div class="leftTab">
        <div class="nabTitle">
          <p>商城</p>
          <div class="line"></div>
          <div class="clear"></div>
        </div>
        <div class="tab">
          <div class="tabList" :class="{tabList_active:item.isActive}" v-for="(item,index) in tabList" :key="index"
            @click="tabEvent(index,item.category_id)">
            <span>{{item.category_name}}</span>
          </div>
        </div>
      </div>

      <div class="rightView">
        <div class="shop" ref="shop" @scroll="shopEvent($event)">
          <div class="shopList" v-for="(item,index) in shopList" :key="index" @click="detail(item.goods_id)">
            <div class="cover">
              <img :src="item.pic" alt="">
            </div>
            <div class="shopName">
              <div class="name">
                <p>{{item.title}}</p>
                <p class="titles">{{item.goods_desc.substr(0,25)}}</p>
                <p class="price">￥{{item.price}}</p>
              </div>
              <div class="line_active">

              </div>
            </div>
          </div>
        </div>
      </div>
      <fiex :shows="fixed" :fatherMethod="goTop" ref="fiex"></fiex>
    </div>
  </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  export default {
    components: {
      fiex
    },
    data() {
      return {
        fixed: true,
        tabList: [],
        shopList:[],
        page:1,
        cetegory_id:0,
        error:false
      }
    },
    created(){
      var that = this;
      this.$fetch('goods/category').then(res=>{
        res.data.category.forEach(item=>{
           item.isActive = false;
        })
        console.log(res);
        this.tabList = res.data.category;
        this.tabList.unshift({
          category_name:'全部',
          isActive:true,
          category_id:0
        })
        this.tabList.forEach(item=>{
            if(item.category_id  == parseInt(that.$route.query.category_id)){
                item.isActive = true;
            }else{
              item.isActive = false
            }
        })
        console.log(this.tabList);
      })

    this.ajaxFunc(parseInt(this.$route.query.category_id));

    },
    methods: {
      ajaxFunc(id,page){
        this.$fetch('goods/list',{
          category_id:id ? id : 0,
          page: page ? page : 1
        }).then(res=>{
           this.shopList = res.data.data;
        })
      },
      goTop(){
        this.$refs.shop.scrollTop = 0;
      },
      shopEvent(e){
        let scrollBottom =
          event.target.scrollHeight -
          event.target.scrollTop -
          event.target.clientHeight;
          if(scrollBottom <= 0){
            if(!this.error){
              this.page += 1;
            }else{
              this.page = this.page;
            }
            console.log(this.page);
            this.shopBotton(this.page);
          }
      },
      // 下拉加载
      shopBotton(page){
        if(!this.error){
          this.$fetch('goods/list',
          {
            category_id:this.category_id,
            page:page
          }).then(res=>{
             res.data.data.forEach(item=>{
               this.shopList.push(item);
             })
             if(res.data.data.length <= 0){
               this.error = true;

             }
          })
        }

      },
      tabEvent(index,id) {
        this.cetegory_id = id;
        // 动态刷新路由参数
        // this.$router.push({
        //     query:{
        //       category_id:id
        //     }
        // });
        this.page = 1;
        for (var i = 0; i < this.tabList.length; i++) {
          this.tabList[i].isActive = false;
        }
        this.tabList[index].isActive = true;
        var data = {};
       if(id == 'undefined'){
          this.ajaxFunc()
       }else{
          this.ajaxFunc(id)
       }

      },
      detail(id){

        this.$router.push({
          path:'/detail',
          query:{
             id:id
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/shopDetail.css");
</style>



// WEBPACK FOOTER //
// src/pages/shopDetail.vue